
import React from "react";
import { RegulationItem } from "../RegulationItem";
import { Clock } from "lucide-react";

export const FishingHours = () => {
  return (
    <RegulationItem 
      value="hours" 
      icon={Clock}
      title="Fishing Hours"
    >
      <p className="text-tribal-neutral">
        2 hours before sunrise to 1 hour after sunset.
      </p>
    </RegulationItem>
  );
};
